<div class="uk-container" xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <nav class="TopNav uk-navbar-container uk-navbar-transparent uk-navbar" uk-navbar>
		<div class="uk-navbar-left">
			<div class="HamburgerMenu">
				<input id="MenuToggle" type="checkbox"/>
				<label class="HamburgerMenu_Btn" for="MenuToggle">
					<span class="HamburgerMenu_Btn--span"></span>
				</label>
				    <span class="CitySelect--1" uk-toggle="target: #ModalCitySelect">
	          <span class="CitySelect_Text--1">{{ cityService.city.NAME }}</span>
	         <span class="IconItem IconItem--arrowRight--1">
		           <img src="/assets/img/icon/arrow-right.svg" uk-svg>
			 </span>
           </span>
				<ul id="top-nav" class="uk-navbar-nav MenuBox"><li id="menu-item-1375" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1375 MenuBox_Item"><a href="https://zolotoykod.ru/">Главная</a></li>
					<li id="menu-item-1860" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1860 MenuBox_Item"><a href="http://zolotoykod.ru/category/action/">Акции</a></li>
					<li id="menu-item-1861" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1861 MenuBox_Item"><a href="http://zolotoykod.ru/category/brand/">Бренды</a></li>
					<li id="menu-item-1859" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-1859 MenuBox_Item"><a href="http://zolotoykod.ru/category/portfolio/">Портфолио</a></li>
					<li id="menu-item-7319" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7319 MenuBox_Item"><a href="http://zolotoykod.ru/contacts/">Компания</a></li>
				</ul>          </div>
		</div>
		<div class="uk-navbar-right">
			<ul class="uk-navbar-nav uk-margin-right">
				<li>
					<a href="tel:88007757399">
								<span class="IconItem IconItem--phone uk-margin-small-right">
									<img src="assets/img/icon/phone.svg" uk-svg>
								</span>
						<span class="PhoneItem--none">8-800-775-73-99</span>
					</a>
				</li>
			</ul>
			<div class="gc-header-profile"></div>
		</div>
		<span uk-toggle="target: #ModalSignIn" class="HeaderProfile_SignIn uk-navbar-item"><span class="IconItem IconItem--signIn"><img src="/assets/img/icon/sign-in.svg" uk-svg="" hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class=" uk-svg" data-svg="/assets/img/icon/sign-in.svg">
  <defs>
    <style>
      .IconSignInPath {
		  fill-rule: evenodd;
	  }
    </style>
  </defs>
  <path id="icon-sign-in" data-name="icon-sign-in" class="IconSignInPath" d="M1182.37,20.614h-0.87a1.749,1.749,0,0,1-1.75-1.753V18.3a4.507,4.507,0,0,0,.84-1.583,0.494,0.494,0,0,1,.17-0.211,1.08,1.08,0,0,0,.15-1.305,0.358,0.358,0,0,1-.09-0.191V13.463a2.579,2.579,0,0,0-.63-1.724,2.429,2.429,0,0,0-1.33-.687,4.387,4.387,0,0,0-1.9.044,2.333,2.333,0,0,0-1.36.921,2.723,2.723,0,0,0-.42,1.389v1.572a0.541,0.541,0,0,1-.12.263,1.1,1.1,0,0,0,.25,1.329,0.468,0.468,0,0,1,.15.293,4.278,4.278,0,0,0,.79,1.415v0.583a1.749,1.749,0,0,1-1.75,1.753h-0.88a4.7,4.7,0,0,0-2.62,2.63v0.877a0.874,0.874,0,0,0,.87.877h12.25a0.876,0.876,0,0,0,.88-0.877V23.245A4.7,4.7,0,0,0,1182.37,20.614Z" transform="translate(-1171 -11)"></path>
</svg></span>
			<span class="SignItem--none">
      Войти
      </span></span>
	</nav>
</div>
